export enum KeyStatisticType {
  PlayerHours,
  UsageHours,
  EquivalentUserHours,
  MaintenanceHours,
  OverdueMaintananeDays,
  OutOfHoursAlerts,
}
